import CopilotProvider from 'copilot-toolkit/CopilotProvider';
import CopilotAppContext from './CopilotAppContext';
import { jsx as _jsx } from "react/jsx-runtime";
const CopilotSetup = ({
  children
}) => {
  return /*#__PURE__*/_jsx(CopilotProvider, {
    children: /*#__PURE__*/_jsx(CopilotAppContext, {
      children: children
    })
  });
};
export default CopilotSetup;